export const findSelectedSubsession = (sessionLengthList, sessionLength) => {
  if (!Array.isArray(sessionLengthList)) {
    return null;
  }

  return (
    sessionLengthList.find((item) => String(item.id) === String(sessionLength)) ||
    null
  );
};

export const getSelectedPaymentInfo = ({
  selectedMedium,
  mediumList,
  activeIndex,
  fallbackMedium,
}) => {
  if (selectedMedium) {
    return selectedMedium;
  }

  if (Array.isArray(mediumList) && activeIndex !== undefined) {
    const indexedMedium = mediumList[activeIndex];
    if (indexedMedium) {
      return indexedMedium;
    }
  }

  if (Array.isArray(mediumList) && mediumList.length > 0) {
    return mediumList.find(
      (item) => item.coaching_pricing !== null && item.coaching_pricing !== "free"
    );
  }

  return fallbackMedium;
};

const isTruthyFlag = (value) => {
  return value === true || value === 1 || value === "1" || value === "true";
};

export const shouldUseGroupBookingEndpoint = ({
  serviceValue,
  serviceType,
  selectedSubsession,
}) => {
  if (parseInt(serviceType, 10) !== 1) {
    return false;
  }

  if (!isTruthyFlag(selectedSubsession && selectedSubsession.is_group_session)) {
    return false;
  }

  return Number(serviceValue) === 1 || Number(serviceValue) === 2;
};

export const shouldUsePaidGroupBookingEndpoint = ({
  serviceValue,
  bookingType,
  selectedSubsession,
}) => {
  return (
    Number(serviceValue) === 2 &&
    bookingType === "paid" &&
    isTruthyFlag(selectedSubsession && selectedSubsession.is_group_session)
  );
};
